import React, { useMemo } from 'react'
import { Col, Row } from 'react-angle-dashboard-components'
import { useHistory } from 'react-router-dom'
import { Question, QuestionContainer, SubText } from '../../components/Question'
import { useUpdateValue } from '../../hooks/use-capture-question'
import useStep from '../../hooks/use-step'
import { Paths } from '../../routes/paths'
import { useGbsContext } from '../../store'
import { GbsStep } from '../../store/interfaces'
import { useStepData } from '../../store/selectors'

const stepKey = 'currentlyMedical'

export const CurrentlyMedical = () => {
  const { dispatch } = useGbsContext()
  const history = useHistory()
  const stepData = useStepData(stepKey)
  const defaultValue = stepData?.value || null
  const { updateValue, isLoading } = useUpdateValue(stepKey)

  const onContinue = async (value: any) => {
    if (isLoading) return

    const wasSuccesfull = await updateValue(value, {
      has_current_carrier: value
    })

    if (!wasSuccesfull) return
    const url = value ? Paths.currentCarrier : Paths.planningPurchasing
    history.push(url)
  }

  const stepConfig: Omit<GbsStep, 'data'> = useMemo(() => {
    return {
      topBar: {
        completedPercentage: 20,
        backCallback: () => history.push(Paths.haveBroker)
      },
      bottomBar: {
        hidden: true
      }
    }
  }, [history])

  useStep(stepKey, stepConfig, dispatch)

  return (
    <QuestionContainer>
      <Row>
        <Col xs={12}>
          <Question
            type="boolean"
            text="Do you currently have medical insurance?"
            defaultValue={defaultValue}
            onChange={onContinue}
          ></Question>
        </Col>
      </Row>

      <SubText>
        All insurance plans are issued by Angle Insurance Company of Utah
      </SubText>
    </QuestionContainer>
  )
}

export default CurrentlyMedical
